module.exports = __webpack_public_path__ + "static/logo_philips-75503779272178a542b1e0bf16aeb2f1.png";